import type { GameContext, GameMiddleware } from "./types";

/**
 * Drives WeatherManager each frame.
 *
 * Behaviour depends on what GameContext provides:
 * - Editor context: ctx.weatherManager is the SceneManager's existing instance.
 *   We call update() on it; SceneManager.render() keeps the volumetric fog pipeline.
 * - Client context: ctx.weatherManager is absent → no-op for now.
 *   (WeatherManager lives in editor/js/; once moved to client/js/ this middleware
 *    will create its own instance automatically.)
 */
export class WeatherMiddleware implements GameMiddleware {
    private ctx!: GameContext;

    init(ctx: GameContext): void {
        this.ctx = ctx;
    }

    update(_delta: number): void {
        this.ctx.weatherManager?.update(this.ctx.getActiveCamera());
    }
}
